/**
 * Zod schema for query decomposition / scope contract output.
 * Used with structured outputs to validate the final mapped scope contract.
 * Mirrors ScopeContract and sub-interfaces in investigation/types.ts.
 *
 * Note: The LLM may return a simpler structure. The query-decomposer maps
 * the raw LLM output into the full ScopeContract, then validates with this schema.
 */

import { z } from 'zod';

export const ScopeSubjectSchema = z.object({
  type: z.string(),
  subtype: z.string().optional(),
  description: z.string(),
  watchlistMatches: z.array(z.string()).optional().default([]),
});

export const BehaviorIndicatorSchema = z.object({
  type: z.string(),
  threshold: z.string(),
});

export const GeographicBoundsSchema = z.object({
  source: z.string(),
  bbox: z.tuple([z.number(), z.number(), z.number(), z.number()]),
  override: z.boolean().default(false),
});

export const TemporalBoundsSchema = z.object({
  start: z.string(),
  end: z.string(),
  source: z.string(),
});

export const ScopeContractSchema = z.object({
  subject: ScopeSubjectSchema,
  behaviorIndicators: z.array(BehaviorIndicatorSchema).optional().default([]),
  geographicBounds: GeographicBoundsSchema,
  temporalBounds: TemporalBoundsSchema,
  exclusions: z.array(z.string()).optional().default([]),
});
